module.exports = __webpack_public_path__ + "9b9866d8d0c4cd5c59ac1e61fa0187b7.svg";